<proffeo-ui-dialog [title]="'task-details-pdf-create-title' | translate">
  <p class="text-sm text-proffeo-muted mb-2">
    {{ 'task-details-pdf-create-description' | translate }}
  </p>

  <div
    [proffeoSpinner]="isLoading()"
    proffeoSpinnerSize="lg"
    class="relative w-full"
  >
    <proffeo-task-details-pdf
      [(sectionsModel)]="sections"
      [(taskActionModel)]="taskAction"
      [(taskAdditionalDetailsModel)]="taskAdditionalDetails"
      [task]="task"
    ></proffeo-task-details-pdf>
  </div>

  <div
    dialog-actions
    class="flex w-full justify-end gap-2"
  >
    <proffeo-ui-button
      (clicked)="close()"
      [disabled]="isLoading()"
      text="task-details-pdf-create-cancel-text"
      variant="primary"
    />
    <proffeo-ui-button
      (clicked)="onPdfGenerate()"
      [disabled]="isLoading()"
      text="task-details-pdf-create-generate-text"
      variant="accent"
    />
  </div>
</proffeo-ui-dialog>
